export default __webpack_public_path__ + "static/media/Initiate's Hood.ee5ee969.jpg";